export class UserCollectionRequest {
  public collectionId: number;
  public userName: string;
  public suspenseId: number;
  public userId: number;
}
